import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { History } from '../../models/history';
import { CrudService } from '../crud.service';

@Injectable({
  providedIn: 'root',
})
export class HistoryService extends CrudService<History> {
  protected basePath = 'history'; // Specific for HistoryService
  public instanceType = 'history'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }
}
